export default __webpack_public_path__ + "static/media/SEC0002.34I-35161_-20424_0.ab33f61f.jpg";